import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Form } from "react-bootstrap";
import axios from "axios";

export default function AnswerDetails() {
  const { id } = useParams(); // assignment_answer_id from URL
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token"); // your auth token

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError("");

      try {
        const res = await axios.post(
          "https://codydealms.codydeasoftech.in/api/teacher/assignmentAnswerDetails",
          {
            page: 1,
            perpage: 10,
            assignment_answer_id: id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (res.data.status && res.data.assignment_answers) {
          setData(res.data);
        } else {
          setError("No assignment data available");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch data from server");
      } finally {
        setLoading(false);
      }
    }

    if (id) fetchData();
    else setError("Invalid assignment ID");
  }, [id, token]);

if (loading) return (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
);   if (error) return <p>{error}</p>;
  if (!data) return <p>No data available</p>;

  const assignmentInfo = data.assignment_answers;
  const questions = data.assignment_answer_details.exam_papers_questions;

  return (
    <div className="container my-4">
      {/* Top Card */}
      <Card className="mb-4 shadow">
        <Card.Body>
          <h3>{assignmentInfo.student_name}</h3>
          <p>
            Roll No: {assignmentInfo.roll} | Semester: {assignmentInfo.semester_name}
          </p>
          <p>
            Start Time: {assignmentInfo.start_time} | End Time: {assignmentInfo.end_time}
          </p>
        </Card.Body>
      </Card>

      {/* Questions */}
      {questions.map((q, qIndex) => {
        const isFileQuestion = q.question_type_name.toLowerCase() !== "text";
        const attempted = isFileQuestion
          ? q.answer_file || q.answer_file_url
            ? "Attempted ✅"
            : "Not Attempted ❌"
          : q.answer
          ? "Attempted ✅"
          : "Not Attempted ❌";

        const options = [q.optionA, q.optionB, q.optionC, q.optionD];

        return (
          <Card
            key={q.id}
            className="mb-4 shadow"
            style={{ border: "2px solid #D8B4FE" }}
          >
            <Card.Header
              style={{
                backgroundColor: "#5856d6",
                color: "#fff",
                fontWeight: "bold",
              }}
            >
              Question {qIndex + 1} - {attempted}
            </Card.Header>

            <Card.Body>
              {isFileQuestion ? (
                <div>
                  <p className="fw-bold">
                    {q.question ? (
                      <a href={q.question} target="_blank" rel="noreferrer">
                        {q.question_type_name} Question (Click to view)
                      </a>
                    ) : (
                      "File Question"
                    )}
                  </p>

                  {q.answer_file_url ? (
                    <a href={q.answer_file_url} target="_blank" rel="noreferrer">
                      View Submitted Answer
                    </a>
                  ) : (
                    <span>No answer submitted</span>
                  )}
                </div>
              ) : (
                <div className="d-flex flex-column gap-2">
                  <p className="fw-bold">{q.question}</p>
                  {options.map((opt, oIndex) => {
                    const optionKey = ["A", "B", "C", "D"][oIndex];
                    const isChecked = q.answer === optionKey;

                    return (
                      <Form.Check
                        key={oIndex}
                        type="radio"
                        name={`question-${q.id}`}
                        checked={isChecked}
                        readOnly
                        label={opt + (isChecked ? " ✅" : "")}
                      />
                    );
                  })}
                </div>
              )}
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
}
